export const countryList = [
	{ "countryName": "Aland Islands", "countryCode": "AX" },
	{ "countryName": "Albania", "countryCode": "AL" },
	{ "countryName": "Algeria", "countryCode": "DZ" },
	{ "countryName": "American, Samoa", "countryCode": "AS" },
	{ "countryName": "Andorra", "countryCode": "AD" },
	{ "countryName": "Angola", "countryCode": "AO" },
	{ "countryName": "Anguilla", "countryCode": "AI" },
	{ "countryName": "Antarctica", "countryCode": "AQ" },
	{ "countryName": "Antigua and Barbuda", "countryCode": "AG" },
	{ "countryName": "Argentina", "countryCode": "AR" },
	{ "countryName": "Armenia", "countryCode": "AM" },
	{ "countryName": "Aruba", "countryCode": "AW" },
	{ "countryName": "Australia", "countryCode": "AU" },
	{ "countryName": "Austria", "countryCode": "AT" },
	{ "countryName": "Azerbaijan", "countryCode": "AZ" },
	{ "countryName": "Bahamas", "countryCode": "BS" },
	{ "countryName": "Bahrain", "countryCode": "BH" },
	{ "countryName": "Bangladesh", "countryCode": "BD" },
	{ "countryName": "Barbados", "countryCode": "BB" },
	{ "countryName": "Belgium", "countryCode": "BE" },
	{ "countryName": "Belize", "countryCode": "BZ" },
	{ "countryName": "Benin", "countryCode": "BJ" },
	{ "countryName": "Bermuda", "countryCode": "BM" },
	{ "countryName": "Bhutan", "countryCode": "BT" },
	{ "countryName": "Bolivia, Plurinational State of", "countryCode": "BO" },
	{ "countryName": "Bonaire, Sint Eustatius and Saba", "countryCode": "BQ" },
	{ "countryName": "Bosnia and Herzegovina", "countryCode": "BA" },
	{ "countryName": "Botswana", "countryCode": "BW" },
	{ "countryName": "Bouvet Island", "countryCode": "BV" },
	{ "countryName": "Brazil", "countryCode": "BR" },
	{ "countryName": "British Indian Ocean Territory", "countryCode": "IO" },
	{ "countryName": "Brunei Darussalam", "countryCode": "BN" },
	{ "countryName": "Bulgaria", "countryCode": "BG" },
	{ "countryName": "Burkina Faso", "countryCode": "BF" },
	{ "countryName": "Burundi", "countryCode": "BI" },
	{ "countryName": "Cambodia", "countryCode": "KH" },
	{ "countryName": "Cameroon", "countryCode": "CM" },
	{ "countryName": "Canada", "countryCode": "CA" },
	{ "countryName": "Cape Verde", "countryCode": "CV" },
	{ "countryName": "Cayman Islands", "countryCode": "KY" },
	{ "countryName": "Central African Republic", "countryCode": "CF" },
	{ "countryName": "Chad", "countryCode": "TD" },
	{ "countryName": "Chile", "countryCode": "CL" },
	{ "countryName": "China", "countryCode": "CN" },
	{ "countryName": "Christmas Island", "countryCode": "CX" },
	{ "countryName": "Cocos (Keeling) Islands", "countryCode": "CC" },
	{ "countryName": "Colombia", "countryCode": "CO" },
	{ "countryName": "Comoros", "countryCode": "KM" },
	{ "countryName": "Congo", "countryCode": "CG" },
	{ "countryName": "Congo, Democratic Republic of the", "countryCode": "CD" },
	{ "countryName": "Cook Islands", "countryCode": "CK" },
	{ "countryName": "Costa Rica", "countryCode": "CR" },
	{ "countryName": "Croatia", "countryCode": "HR" },
	{ "countryName": "Curacao", "countryCode": "CW" },
	{ "countryName": "Cyprus", "countryCode": "CY" },
	{ "countryName": "Czech Republic", "countryCode": "CZ" },
	{ "countryName": "Denmark", "countryCode": "DK" },
	{ "countryName": "Djibouti", "countryCode": "DJ" },
	{ "countryName": "Dominica", "countryCode": "DM" },
	{ "countryName": "Dominican Republic", "countryCode": "DO" },
	{ "countryName": "Ecuador", "countryCode": "EC" },
	{ "countryName": "Egypt", "countryCode": "EG" },
	{ "countryName": "El Salvador", "countryCode": "SV" },
	{ "countryName": "Equatorial Guinea", "countryCode": "GQ" },
	{ "countryName": "Estonia", "countryCode": "EE" },
	{ "countryName": "Ethiopia", "countryCode": "ET" },
	{ "countryName": "Falkland Islands (Malvinas)", "countryCode": "FK" },
	{ "countryName": "Faroe Islands", "countryCode": "FO" },
	{ "countryName": "Fiji", "countryCode": "FJ" },
	{ "countryName": "Finland", "countryCode": "FI" },
	{ "countryName": "France", "countryCode": "FR" },
	{ "countryName": "French Guiana", "countryCode": "GF" },
	{ "countryName": "French Polynesia", "countryCode": "PF" },
	{ "countryName": "French Southern Territories", "countryCode": "TF" },
	{ "countryName": "Gabon", "countryCode": "GA" },
	{ "countryName": "Gambia", "countryCode": "GM" },
	{ "countryName": "Georgia", "countryCode": "GE" },
	{ "countryName": "Germany", "countryCode": "DE" },
	{ "countryName": "Ghana", "countryCode": "GH" },
	{ "countryName": "Gibraltar", "countryCode": "GI" },
	{ "countryName": "Greece", "countryCode": "GR" },
	{ "countryName": "Greenland", "countryCode": "GL" },
	{ "countryName": "Grenada", "countryCode": "GD" },
	{ "countryName": "Guadeloupe", "countryCode": "GP" },
	{ "countryName": "Guam", "countryCode": "GU" },
	{ "countryName": "Guatemala", "countryCode": "GT" },
	{ "countryName": "Guernsey", "countryCode": "GG" },
	{ "countryName": "Guinea-Bissau", "countryCode": "GW" },
	{ "countryName": "Guyana", "countryCode": "GY" },
	{ "countryName": "Haiti", "countryCode": "HT" },
	{ "countryName": "Heard Island and Mcdonald Islands", "countryCode": "HM" },
	{ "countryName": "Holy See (Vatican City State)", "countryCode": "VA" },
	{ "countryName": "Honduras", "countryCode": "HN" },
	{ "countryName": "Hong Kong", "countryCode": "HK" },
	{ "countryName": "Hungary", "countryCode": "HU" },
	{ "countryName": "Hungary", "countryCode": "HU" },
	{ "countryName": "Iceland", "countryCode": "IS" },
	{ "countryName": "India", "countryCode": "IN" },
	{ "countryName": "Indonesia", "countryCode": "ID" },
	{ "countryName": "Ireland", "countryCode": "IE" },
	{ "countryName": "Isle of Man", "countryCode": "IM" },
	{ "countryName": "Israel", "countryCode": "IL" },
	{ "countryName": "Italy", "countryCode": "IT" },
	{ "countryName": "Jamaica", "countryCode": "JM" },
	{ "countryName": "Japan", "countryCode": "JP" },
	{ "countryName": "Jersey", "countryCode": "JE" },
	{ "countryName": "Jordan", "countryCode": "JO" },
	{ "countryName": "Kazakhstan", "countryCode": "KZ" },
	{ "countryName": "Kenya", "countryCode": "KE" },
	{ "countryName": "Kiribati", "countryCode": "KI" },
	{ "countryName": "Korea, Republic of", "countryCode": "KR" },
	{ "countryName": "Kuwait", "countryCode": "KW" },
	{ "countryName": "Kyrgyzstan", "countryCode": "KG" },
	{ "countryName": "Lao People’s Democratic Republic", "countryCode": "LA" },
	{ "countryName": "Latvia", "countryCode": "LV" },
	{ "countryName": "Lebanon", "countryCode": "LB" },
	{ "countryName": "Lesotho", "countryCode": "LS" },
	{ "countryName": "Libya", "countryCode": "LY" },
	{ "countryName": "Liechtenstein", "countryCode": "LI" },
	{ "countryName": "Lithuania", "countryCode": "LT" },
	{ "countryName": "Luxembourg", "countryCode": "LU" },
	{ "countryName": "Macao", "countryCode": "MO" },
	{ "countryName": "Madagascar", "countryCode": "MG" },
	{ "countryName": "Malawi", "countryCode": "MW" },
	{ "countryName": "Malaysia", "countryCode": "MY" },
	{ "countryName": "Maldives", "countryCode": "MV" },
	{ "countryName": "Mali", "countryCode": "ML" },
	{ "countryName": "Malta", "countryCode": "MT" },
	{ "countryName": "Marshall Islands", "countryCode": "MH" },
	{ "countryName": "Martinique", "countryCode": "MQ" },
	{ "countryName": "Mauritania", "countryCode": "MR" },
	{ "countryName": "Mauritius", "countryCode": "MU" },
	{ "countryName": "Mayotte", "countryCode": "YT" },
	{ "countryName": "Mexico", "countryCode": "MX" },
	{ "countryName": "Micronesia (Federated States of)", "countryCode": "FM" },
	{ "countryName": "Moldova, Republic of", "countryCode": "MD" },
	{ "countryName": "Monaco", "countryCode": "MC" },
	{ "countryName": "Mongolia", "countryCode": "MN" },
	{ "countryName": "Montenegro", "countryCode": "ME" },
	{ "countryName": "Montserrat", "countryCode": "MS" },
	{ "countryName": "Morocco", "countryCode": "MA" },
	{ "countryName": "Mozambique", "countryCode": "MZ" },
	{ "countryName": "Myanmar", "countryCode": "MM" },
	{ "countryName": "Namibia", "countryCode": "NA" },
	{ "countryName": "Nauru", "countryCode": "NR" },
	{ "countryName": "Nepal", "countryCode": "NP" },
	{ "countryName": "Netherlands", "countryCode": "NL" },
	{ "countryName": "New Caledonia", "countryCode": "NC" },
	{ "countryName": "New Zealand", "countryCode": "NZ" },
	{ "countryName": "Nicaragua", "countryCode": "NI" },
	{ "countryName": "Niger", "countryCode": "NE" },
	{ "countryName": "Nigeria", "countryCode": "NG" },
	{ "countryName": "Niue", "countryCode": "NU" },
	{ "countryName": "Norfolk Island", "countryCode": "NF" },
	{ "countryName": "North Macedonia", "countryCode": "MK" },
	{ "countryName": "Northern Mariana Islands", "countryCode": "MP" },
	{ "countryName": "Norway", "countryCode": "NO" },
	{ "countryName": "Oman", "countryCode": "OM" },
	{ "countryName": "Pakistan", "countryCode": "PK" },
	{ "countryName": "Palau", "countryCode": "PW" },
	{ "countryName": "Palestine, State of", "countryCode": "PS" },
	{ "countryName": "Panama", "countryCode": "PA" },
	{ "countryName": "Papua New Guinea", "countryCode": "PG" },
	{ "countryName": "Paraguay", "countryCode": "PY" },
	{ "countryName": "Peru", "countryCode": "PE" },
	{ "countryName": "Philippines", "countryCode": "PH" },
	{ "countryName": "Pitcairn", "countryCode": "PN" },
	{ "countryName": "Poland", "countryCode": "PL" },
	{ "countryName": "Portugal", "countryCode": "PT" },
	{ "countryName": "Puerto Rico", "countryCode": "PR" },
	{ "countryName": "Qatar", "countryCode": "QA" },
	{ "countryName": "Romania", "countryCode": "RO" },
	{ "countryName": "Russian Federation", "countryCode": "RU" },
	{ "countryName": "Réunion", "countryCode": "RE" },
	{ "countryName": "Saint Barthélemy", "countryCode": "BL" },
	{ "countryName": "Saint Helena, Ascension and Tristan da Cunha", "countryCode": "SH" },
	{ "countryName": "Saint Kitts and Nevis", "countryCode": "KN" },
	{ "countryName": "Saint Lucia", "countryCode": "LC" },
	{ "countryName": "Saint Martin (French part)", "countryCode": "MF" },
	{ "countryName": "Saint Pierre and Miquelon", "countryCode": "PM" },
	{ "countryName": "Saint Vincent and the Grenadines", "countryCode": "VC" },
	{ "countryName": "Samoa", "countryCode": "WS" },
	{ "countryName": "San Marino", "countryCode": "SM" },
	{ "countryName": "Saudi Arabia", "countryCode": "SA" },
	{ "countryName": "Senegal", "countryCode": "SN" },
	{ "countryName": "Serbia", "countryCode": "RS" },
	{ "countryName": "Seychelles", "countryCode": "SC" },
	{ "countryName": "Singapore", "countryCode": "SG" },
	{ "countryName": "Sint Maarten (Dutch part)", "countryCode": "SX" },
	{ "countryName": "Slovakia", "countryCode": "SK" },
	{ "countryName": "Slovenia", "countryCode": "SI" },
	{ "countryName": "Solomon Islands", "countryCode": "SB" },
	{ "countryName": "Somalia", "countryCode": "SO" },
	{ "countryName": "South Africa", "countryCode": "ZA" },
	{ "countryName": "South Georgia and the South Sandwich Islands", "countryCode": "GS" },
	{ "countryName": "Spain", "countryCode": "ES" },
	{ "countryName": "Sri Lanka", "countryCode": "LK" },
	{ "countryName": "Suriname", "countryCode": "SR" },
	{ "countryName": "Svalbard and Jan Mayen", "countryCode": "SJ" },
	{ "countryName": "Sweden", "countryCode": "SE" },
	{ "countryName": "Switzerland", "countryCode": "CH" },
	{ "countryName": "São Tomé and Príncipe", "countryCode": "ST" },
	{ "countryName": "Taiwan", "countryCode": "TW" },
	{ "countryName": "Tajikistan", "countryCode": "TJ" },
	{ "countryName": "Tanzania, United Republic of", "countryCode": "TZ" },
	{ "countryName": "Thailand", "countryCode": "TH" },
	{ "countryName": "Togo", "countryCode": "TG" },
	{ "countryName": "Tokelau", "countryCode": "TK" },
	{ "countryName": "Tonga", "countryCode": "TO" },
	{ "countryName": "Trinidad and Tobago", "countryCode": "TT" },
	{ "countryName": "Tunisia", "countryCode": "TN" },
	{ "countryName": "Turkey", "countryCode": "TR" },
	{ "countryName": "Turkmenistan", "countryCode": "TM" },
	{ "countryName": "Turks and Caicos Islands", "countryCode": "TC" },
	{ "countryName": "Tuvalu", "countryCode": "TV" },
	{ "countryName": "Uganda", "countryCode": "UG" },
	{ "countryName": "Ukraine", "countryCode": "UA" },
	{ "countryName": "United Arab Emirates", "countryCode": "AE" },
	{ "countryName": "United Kingdom", "countryCode": "GB" },
	{ "countryName": "United States", "countryCode": "US" },
	{ "countryName": "United States Minor Outlying Islands", "countryCode": "UM" },
	{ "countryName": "Uruguay", "countryCode": "UY" },
	{ "countryName": "Uzbekistan", "countryCode": "UZ" },
	{ "countryName": "Vanatu", "countryCode": "VU" },
	{ "countryName": "Venezuela", "countryCode": "VE" },
	{ "countryName": "Vietnam", "countryCode": "VN" },
	{ "countryName": "Virgin Islands, British", "countryCode": "VG" },
	{ "countryName": "Virgin Islands, U.S.", "countryCode": "VI" },
	{ "countryName": "Wallis and Futuna", "countryCode": "WF" },
	{ "countryName": "Western Sahara", "countryCode": "EH" },
	{ "countryName": "Yemen", "countryCode": "YE" },
	{ "countryName": "Zambia", "countryCode": "ZM" }
];
